import {
  Button,
  Divider,
  IconButton,
  Input,
  Select,
  Spinner,
  Switch,
  Text,
  Tooltip,
  useDisclosure
} from '@chakra-ui/react';
import React, { useEffect, useMemo, useState } from 'react';
import {
  fetchAPI,
  generateAPI,
  refreshAPI,
  deleteAPI
} from '../ducks/fflSelectActions';
import { useDispatch } from 'react-redux';
import { setStoreConfiguration } from '@/redux/app-slice';
import { getAPIKeyDetail } from '@/redux/app-selectors';
import {
  CheckIcon,
  CopyIcon,
  DeleteIcon,
  MinusIcon,
  RepeatIcon
} from '@chakra-ui/icons';
import fflSelectInterface from '@/model/ffl-select.mjs';
import ConfirmationModal from '@/common/ConfirmationModal';
import {
  getAutomatedTransferWorkflowStatus,
  getIsEncryptionKeyGenerated,
  getIsEncryptionKeyRemoved,
  getIsGneratingEncryptionKey,
  getIsRemovingEncryptionKey,
  getIsStoreConfigurationUpdated,
  getIsUpdatingStoreConfiguration
} from '../ducks/selectors';
import {
  callToGenerateEncryptionKey,
  callToRemoveEncryptionKey,
  callToUpdateAutomateTransferWorkflow,
  callToUpdateStoreConfiguration,
  setAutomateTransferWorkflow,
  setIsEncryptionKeyRemoved,
  setisEncryptionKeyGenerated
} from '../ducks/slice';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { storeConfigurationMagentoSchema, storeConfigurationSchema } from '@/model/yupSchema.mjs';
import { keyType } from '@/queue/types';
import * as constants from '@/utils/constants';
import { UserAgents } from '../types';
import { client } from '@/api/backoffice-api';
import AppConfig from '@/utils/app-config.mjs';
import { eCommercePlatform } from '@/model/Constants';
import { maskValue } from '@/utils/utils';
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { analyticsEvents } from '@/utils/analyticsEvents';
interface FFLSelectProps {
  doRefresh: number;
}

interface AutomateTransferWorkflowProps {
  doRefresh: number;
  selectedAgentEmail: string;
  setSelectedAgentEmail: (val: string) => void;
  setIsActionDisabled: (val: boolean) => void;
}

interface ConfigurationFormProps {
  isActionDisabled: boolean;
  setIsActionDisabled: (val: boolean) => void;
  selectedAgentEmail: string;
  setSelectedAgentEmail: (val: string) => void;
  selectedCommercePlatform: string
  setSelectedCommercePlatform: (val: string) => void;
}



export default function FFLSelect({ doRefresh }: FFLSelectProps) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [toggle, setToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [processLoading, setProcessLoading] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedAgentEmail, setSelectedAgentEmail] = useState<string>('');
  const [selectedCommercePlatform, setSelectedCommercePlatform] = useState<string>('');
  const [isActionDisabled, setIsActionDisabled] = useState(true);
  const [copyItem, setCopyItem] = useState('');
  const [moduleVersion, setModuleVersion] = useState('-');

  const APIKeyDetail = getAPIKeyDetail();
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (doRefresh === 2) {
      fetchAPIData();
    }
  }, [doRefresh]);

  const fetchAPIData = async () => {
    const getAPI = await fetchAPI();
    setIsLoading(false);
    setSelectedCommercePlatform(getAPI?.e_commerce_platform || "")
    dispatch(setStoreConfiguration(getAPI));
    setIsLoading(false);
  };
  const handleCopy = (apikey: string, type:string) => {
    setIsCopy(true);
    setCopyItem(type)
    navigator.clipboard.writeText(apikey);
    setTimeout(() => {
      setCopyItem('')
      setIsCopy(false);
    }, 1000);
  };
  const hideAPI = (apiKey: string) => {
    const last4api = apiKey?.slice(apiKey?.length - 4, apiKey?.length);
    let astrik = '';
    for (let i = 0; i < apiKey?.length - 4; i++) {
      astrik += '*';
    }
    return astrik + last4api;
  };
  const handleToggle = async () => {
    try {
      setIsLoading(true);
      setProcessLoading(true);
      if (toggle) {
        await deleteAPI();
        setToggle(!toggle);
        dispatch(setStoreConfiguration({ ...APIKeyDetail, api_key: null }));
        onClose();
      } else {
        if (APIKeyDetail?.id) {
          const getAPI: fflSelectInterface = await refreshAPI();
          dispatch(setStoreConfiguration(getAPI));
          setToggle(!toggle);
        } else {
          const getAPI: fflSelectInterface = await generateAPI();
          dispatch(setStoreConfiguration(getAPI));
          setToggle(!toggle);
        }
      }
    } catch (error) {
      setToggle(false);
      setIsLoading(false);
      setProcessLoading(false);
    } finally {
      setIsLoading(false);
      setProcessLoading(false);
    }
  };
  const handleRefreshAPI = async () => {
    setProcessLoading(true);
    const getAPI: fflSelectInterface = await refreshAPI();
    if (getAPI?.api_key) {
      dispatch(setStoreConfiguration(getAPI));
      setIsRefresh(false);
      setProcessLoading(false);
      onClose();
    }
  };
  const refreshAPIClose = () => {
    onClose();
    setIsRefresh(false);
  };

  const onChangePlatForm = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value) {
      setIsActionDisabled(false);
    }
    setSelectedCommercePlatform(event.target.value);
  };

  useEffect(() => {
    if (!APIKeyDetail?.api_key) {
      setToggle(false);
    } else {
      setToggle(true);
    }
    if(APIKeyDetail?.module_version){
      setModuleVersion(APIKeyDetail?.module_version)
    }
  }, [APIKeyDetail]);
  return (
    <>
      <div className="ffl-select-admin-tab">
        <Text fontSize="30px" as="b">
          FFLSelect Integration
        </Text>
        {toggle ? (
          <Button
            leftIcon={
              <IconButton
                isRound={true}
                variant="solid"
                colorScheme="teal"
                aria-label="Done"
                size="xs"
                icon={<CheckIcon />}
              />
            }
            isDisabled={isLoading}
            size="lg"
            colorScheme="teal"
            variant="outline"
            className="btn-toggle"
            onClick={onOpen}
          >
            Toggle Enabled
          </Button>
        ) : (
          <Button
            leftIcon={
              isLoading ? (
                <Spinner size="sm" />
              ) : (
                <IconButton
                  isRound={true}
                  variant="solid"
                  colorScheme="red"
                  aria-label="Done"
                  size="xs"
                  icon={<MinusIcon />}
                />
              )
            }
            isDisabled={isLoading}
            size="lg"
            colorScheme="red"
            variant="outline"
            className="btn-toggle"
            onClick={handleToggle}
          >
            Toggle Disabled
          </Button>
        )}
      </div>
      {
        <div className='pending-transfer-auto-assign-agent'>
          <Text className='pending-transfer-auto-assign-label'>E-commerce Platform:</Text>
          <Select
            className="pending-transfer-auto-assign-input"
            placeholder="-Select Platform-"
            value={selectedCommercePlatform}
            onChange={onChangePlatForm}
          >
            {constants.E_COMMERCE_PLATFORM.map(platforms => <option  key={platforms.value} value={platforms.value}>{platforms.name} </option>)}
          </Select>
        </div>
      }
      {
        <div className='pending-transfer-auto-assign-agent'>
          <Text className='pending-transfer-auto-assign-label'>FFL Checkout Version:</Text>
          <Text className='pending-transfer-auto-assign-label'>{moduleVersion}</Text>
        </div>
      }
      <>
      {(APIKeyDetail?.store_id && APIKeyDetail?.store_id !== undefined) && (
          <div className="" style={{ marginTop: '50px' }}>
            <h2 className="fflselect-section__title">FFL Select API Key</h2>
            <div className="fflselect-api-container">
              <p>
                {isVisible && APIKeyDetail?.store_id
                  ? maskValue(APIKeyDetail.store_id, 4, 14)
                  : hideAPI(APIKeyDetail.store_id as string)}
              </p>
              <Tooltip
                label={<div className="copy-tooltip">Copied</div>}
                isOpen={isCopy && copyItem === 'id'}
                placement="top"
              >
                <Button
                  variant="outline"
                  className="ffl-copy-regenerate-btn"
                  leftIcon={<CopyIcon />}
                  margin="0px 20px"
                  onClick={() => APIKeyDetail?.store_id && handleCopy(APIKeyDetail?.store_id, 'id')}
                >
                  Copy
                </Button>
              </Tooltip>
            </div>
          </div>
          )}
        </>
      {toggle && (
        <>
          <div className="" style={{ marginTop: '50px' }}>
            <h2 className="fflselect-section__title">FFL Select Secret</h2>
            <div className="fflselect-api-container">
              <p>
                {isVisible && APIKeyDetail.api_key
                  ? maskValue(APIKeyDetail.api_key, 4, 14)
                  : hideAPI(APIKeyDetail.api_key as string)}
              </p>

              {/* <button
                className="fflselect-show-hide-btn"
                onClick={() => setIsVisible(!isVisible)}
              >
                {isVisible ? 'Hide' : 'Show'}
              </button> */}
              <Tooltip
                label={<div className="copy-tooltip">Copied</div>}
                isOpen={isCopy && copyItem === 'apiKey'}
                placement="top"
              >
                <Button
                  variant="outline"
                  className="ffl-copy-regenerate-btn"
                  leftIcon={<CopyIcon />}
                  margin="0px 20px"
                  onClick={() => APIKeyDetail?.api_key && handleCopy(APIKeyDetail?.api_key, 'apiKey')}
                >
                  Copy
                </Button>
              </Tooltip>
              <Button
                variant="outline"
                className="ffl-copy-regenerate-btn"
                leftIcon={<RepeatIcon />}
                onClick={() => {
                  onOpen();
                  setIsRefresh(true);
                }}
              >
                Regenerate
              </Button>
            </div>
          </div>
        </>
      )}
      <EncryptionKey apiKeyDetail={APIKeyDetail} handleCopy={handleCopy} />
      <div className="" style={{ marginTop: '50px', display: 'flex' }}>
        <AutomateTransferWorkflow
          doRefresh={doRefresh}
          selectedAgentEmail={selectedAgentEmail}
          setSelectedAgentEmail={setSelectedAgentEmail}
          setIsActionDisabled={setIsActionDisabled}
        />
      </div>

      {isRefresh ? (
        <ConfirmationModal
          isOpen={isOpen}
          modalHeader={'Regenrate API key'}
          onClose={refreshAPIClose}
          isCancelBtnDisable={false}
          isConfirmBtnDisable={processLoading}
          isConfirmBtnLoading={processLoading}
          onClickConfirmBtn={handleRefreshAPI}
          modalContent={
            <>
              This will remove the existing key and generate another API key. Do
              you want to proceed?
            </>
          }
        />
      ) : (
        <ConfirmationModal
          isOpen={isOpen}
          modalHeader={'Disable FFL select integration'}
          onClose={onClose}
          isCancelBtnDisable={false}
          isConfirmBtnDisable={processLoading}
          isConfirmBtnLoading={processLoading}
          onClickConfirmBtn={handleToggle}
          modalContent={
            <>
              This will disable your FFL select integration. The FFL select
              application may not work as expected. Do you want to proceed?{' '}
            </>
          }
        />
      )}
      <Divider className="divider" />
      <ConfigurationForm
        isActionDisabled={isActionDisabled}
        setIsActionDisabled={setIsActionDisabled}
        selectedAgentEmail={selectedAgentEmail}
        setSelectedAgentEmail={setSelectedAgentEmail}
        selectedCommercePlatform={selectedCommercePlatform}
        setSelectedCommercePlatform={setSelectedCommercePlatform}
      />
    </>
  );
}

function AutomateTransferWorkflow({ doRefresh, selectedAgentEmail, setSelectedAgentEmail, setIsActionDisabled }: AutomateTransferWorkflowProps) {
  const [toggle, setToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const dispatch = useDispatch();
  const automatedWorkflowStatus = getAutomatedTransferWorkflowStatus();
  const [agents, setAgents] = useState<UserAgents[]>([]);

  async function getAgents() {
    const response = await client.get(
      `${AppConfig.fflGetStoreApi}/stores/users`
    );
    if (response?.data && response?.data?.length > 0) {
      const agents = response.data || [];
      setAgents(agents);
    }
  }

  useEffect(() => {
    getAgents();
  }, [])

  useEffect(() => {
    if (doRefresh === 2) {
      dispatchTransferWorkflow;
    }
  }, [doRefresh, automatedWorkflowStatus]);

  const dispatchTransferWorkflow = useMemo(() => {
    if (automatedWorkflowStatus) {
      setToggle(true);
      setIsLoading(false);
    } else setToggle(false);
    setIsLoading(false);
  }, [automatedWorkflowStatus]);
  const configDetails = getAPIKeyDetail();

  useEffect(() => {
    if (configDetails) {
      setSelectedAgentEmail(configDetails.agent_email || '');
    }
  }, [configDetails]);

  const modelHeaderhandler = useMemo(() => {
    let modelHeader = 'Enable Pending Transfers';
    let modelContext = 'Do you want to enable pending status for transfers?';
    if (automatedWorkflowStatus) {
      modelHeader = 'Disable Pending Transfers';
      modelContext = 'Do you want to disable pending status for transfers?';
    }
    return { modelHeader, modelContext };
  }, [automatedWorkflowStatus]);

  const confirmationModelHandler = async () => {
    dispatch(setAutomateTransferWorkflow(!automatedWorkflowStatus));
    dispatch(callToUpdateAutomateTransferWorkflow());
    onClose();
  };

  const onChangeAgent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value) {
      setIsActionDisabled(false);
    }
    setSelectedAgentEmail(event.target.value);
  };

  return (
    <>
      <div className='automate-pending-transfer-workflow-wrapper'>
        <div className='pending-transfer-edit-wrapper'>
          <Text style={{ fontWeight: 'bold', fontSize: '20px' }}>
            Pending Transfers
          </Text>
          <div className="transfer-edit__optin-optout-switch-wrap transfer-workflow-switch">
            <Switch
              size="md"
              isChecked={automatedWorkflowStatus || false}
              onChange={onOpen}
              disabled={Boolean(!configDetails?.api_key)}
            />
          </div>
        </div>
        {!automatedWorkflowStatus && (
          <div className='pending-transfer-auto-assign-agent'>
            <Text className='pending-transfer-auto-assign-label'>Auto-assign Agent:</Text>
            <Select
              className="pending-transfer-auto-assign-input"
              placeholder="-Select Agent-"
              value={selectedAgentEmail}
              onChange={onChangeAgent}
            >
              {agents.map(agent => <option key={agent.email} value={agent.email}>{`${agent.firstName} ${agent.lastName}`} </option>)}
            </Select>
          </div>)}
      </div>
      <ConfirmationModal
        isOpen={isOpen}
        modalHeader={modelHeaderhandler.modelHeader}
        onClose={onClose}
        isCancelBtnDisable={false}
        isConfirmBtnDisable={false}
        isConfirmBtnLoading={false}
        onClickConfirmBtn={confirmationModelHandler}
        modalContent={<>{modelHeaderhandler.modelContext}</>}
      />
    </>
  );
}

function EncryptionKey({ apiKeyDetail, handleCopy }: { apiKeyDetail: fflSelectInterface, handleCopy:(val: string, type:string) => void }) {
  const {
    isOpen: isRegenerateEncryptionModalOpen,
    onClose: onCloseRegenerateEncryptionModal,
    onOpen: onOpenRegenerateEncryptionModal
  } = useDisclosure();
  const dispatch = useDispatch();
  const {
    isOpen: isDeleteEncryptionModalOpen,
    onClose: onCloseDeleteEncryptionModalOpen,
    onOpen: onOpenDeleteEncryptionModalOpen
  } = useDisclosure();

  const onConfirmGenerateEncryptionKey = () => {
    dispatch(callToGenerateEncryptionKey());
  };

  const onConfirmRemoveEncryptionKey = () => {
    dispatch(callToRemoveEncryptionKey());
  };

  const isEncryptionKeyGenerated = getIsEncryptionKeyGenerated();
  const isGneratingEncryptionKey = getIsGneratingEncryptionKey();
  const isEncryptionKeyRemoved = getIsEncryptionKeyRemoved();
  const isRemovingEncryptionKey = getIsRemovingEncryptionKey();

  useEffect(() => {
    if (isEncryptionKeyGenerated) {
      onCloseRegenerateEncryptionModal();
      dispatch(setisEncryptionKeyGenerated(false));
    }
    if (isEncryptionKeyRemoved) {
      onCloseDeleteEncryptionModalOpen();
      dispatch(setIsEncryptionKeyRemoved(false));
    }
  }, [isEncryptionKeyGenerated, isEncryptionKeyRemoved]);

  return (
    <div className="fflselect-section">
      <h2 className="fflselect-section__title">
        {constants.FFL_ENCRYPTION_KEY}
      </h2>
      <div className="fflselect-api-container">
        <p>{apiKeyDetail.encryption_key && maskValue(apiKeyDetail.encryption_key, 4, 14) || constants.NO_KEY_GENERATED}</p>
        <Button
          variant="outline"
          className="ffl-copy-regenerate-btn"
          leftIcon={<CopyIcon />}
          onClick={() => {apiKeyDetail.encryption_key && handleCopy(apiKeyDetail.encryption_key, 'encryption_key')}}
          isDisabled={Boolean(!apiKeyDetail.encryption_key)}
        >
          Copy
        </Button>
        <Button
          variant="outline"
          className="ffl-copy-regenerate-btn"
          leftIcon={<RepeatIcon />}
          onClick={() => {
            onOpenRegenerateEncryptionModal();
          }}
          isDisabled={Boolean(!apiKeyDetail?.api_key)}
        >
          {apiKeyDetail.encryption_key
            ? constants.REGENERATE_TEXT
            : constants.GENERATE_TEXT}
        </Button>
      </div>
      <ConfirmationModal
        isOpen={isRegenerateEncryptionModalOpen}
        modalHeader={'Regenerate FFL encryption key'}
        onClose={onCloseRegenerateEncryptionModal}
        isCancelBtnDisable={isGneratingEncryptionKey}
        isConfirmBtnDisable={isGneratingEncryptionKey}
        isConfirmBtnLoading={isGneratingEncryptionKey}
        onClickConfirmBtn={onConfirmGenerateEncryptionKey}
        modalContent={
          <>
            {apiKeyDetail.encryption_key
              ? constants.FFL_RE_CREATE_ENCRYPTION_KEY
              : constants.FFL_CREATE_ENCRYPTION_KEY}
          </>
        }
      />
      <ConfirmationModal
        isOpen={isDeleteEncryptionModalOpen}
        modalHeader={'Remove FFL encryption key'}
        onClose={onCloseDeleteEncryptionModalOpen}
        isCancelBtnDisable={isRemovingEncryptionKey}
        isConfirmBtnDisable={isRemovingEncryptionKey}
        isConfirmBtnLoading={isRemovingEncryptionKey}
        onClickConfirmBtn={onConfirmRemoveEncryptionKey}
        modalContent={<>{constants.FFL_REMOVE_ENCRYPTION_KEY}</>}
      />
    </div>
  );
}

function ConfigurationForm({ isActionDisabled, setIsActionDisabled, selectedAgentEmail, setSelectedAgentEmail,selectedCommercePlatform, setSelectedCommercePlatform }: ConfigurationFormProps) {
  const formMapping = [
    {
      label: 'Geocoding map key',
      inputType: 'text',
      fieldName: 'geocodingMapKey',
      isWebHook: false
    },
  ];

  enum FormFields {
    geocodingMapKey = 'geocodingMapKey',
  }
  const dispatch = useDispatch();
  const configDetails = getAPIKeyDetail();
  const isUpdatingStoreConfiguration = getIsUpdatingStoreConfiguration();
  const initialAllowPreferredLicenseUpgrade = Boolean(configDetails.allow_preferred_license_upgrade);
  const [allowPreferredLicenseUpgrade, setAllowPreferredLicenseUpgrade] = useState<boolean>(
    initialAllowPreferredLicenseUpgrade
  );
  const initialData = {
    geocodingMapKey: configDetails.google_map_key || '',
    fflTransferApiUrl: configDetails.ffl_transfer_api_url || '',
    storeUrl: configDetails.ffl_select_url || '',
    selectTransferWebhook: configDetails.master_proof_reciever_webhook || '',
    selectAdminconfiguationwebhook:
      configDetails.store_configuration_webhook || '',
  };
  const isBigCommercePlatform = selectedCommercePlatform === eCommercePlatform.BIG_COMMERCE
  const isWooCommercePlatform = selectedCommercePlatform === eCommercePlatform.WOO_COMMERCE

  const {
    handleSubmit,
    register,
    formState: { errors },
    getValues,
    reset
  } = useForm({
    resolver: yupResolver(storeConfigurationSchema),
    mode: 'onChange',
    values: initialData
  });

  useEffect(() => {
    setAllowPreferredLicenseUpgrade(Boolean(configDetails.allow_preferred_license_upgrade));
  }, [configDetails.allow_preferred_license_upgrade]);

  const updateIsActionDisabledState = (formValues: Record<string, unknown>, nextAllowPreferredLicenseUpgrade = allowPreferredLicenseUpgrade) => {
    const isFormChanged = JSON.stringify(formValues) !== JSON.stringify(initialData);
    const isAgentChanged = configDetails?.agent_email !== selectedAgentEmail;
    const isPlatformChanged = (configDetails?.e_commerce_platform || '') !== (selectedCommercePlatform || '');
    const isPreferredLicenseUpgradeChanged = initialAllowPreferredLicenseUpgrade !== nextAllowPreferredLicenseUpgrade;
    setIsActionDisabled(!(isFormChanged || isAgentChanged || isPlatformChanged || isPreferredLicenseUpgradeChanged));
  };

  const submitHandler: SubmitHandler<{
    geocodingMapKey: string;
    selectTransferWebhook?: string;
    selectAdminconfiguationwebhook?: string;
  }> = (data) => {
    if (
      JSON.stringify(initialData) !== JSON.stringify(data) ||
      configDetails?.agent_email !== selectedAgentEmail ||
      (configDetails?.e_commerce_platform || '') !== (selectedCommercePlatform || '') ||
      initialAllowPreferredLicenseUpgrade !== allowPreferredLicenseUpgrade
    ) {
      const payload = {
        ...(initialData.geocodingMapKey !== data.geocodingMapKey
          ? { google_map_key: data.geocodingMapKey as string }
          : {}),
        ...(initialData.selectTransferWebhook !== data.selectTransferWebhook
          ? {
            master_proof_reciever_webhook:
              data.selectTransferWebhook as string
          }
          : {}),
        ...(initialData.selectAdminconfiguationwebhook !==
          data.selectAdminconfiguationwebhook
          ? {
            store_configuration_webhook:
              data.selectAdminconfiguationwebhook as string
          }
          : {}),
          ...(selectedAgentEmail ? {agent_email: selectedAgentEmail}:{}),
          ...(selectedCommercePlatform ? {e_commerce_platform: selectedCommercePlatform}:{}),
          ...(initialAllowPreferredLicenseUpgrade !== allowPreferredLicenseUpgrade
            ? { allow_preferred_license_upgrade: allowPreferredLicenseUpgrade }
            : {}),
      };
      dispatch(callToUpdateStoreConfiguration(payload));
      setIsActionDisabled(true);
    }
  };

  const onCancelHandler = () => {
    reset(initialData);
    setIsActionDisabled(true);
    setSelectedAgentEmail(configDetails?.agent_email || '');
    setSelectedCommercePlatform(configDetails?.e_commerce_platform || '');
    setAllowPreferredLicenseUpgrade(initialAllowPreferredLicenseUpgrade);
  };

  const onChangeFeild = () => {
    const formValues = getValues();
    updateIsActionDisabledState(formValues);
  };
  const onChangePreferredLicenseUpgrade = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.checked;
    setAllowPreferredLicenseUpgrade(nextValue);
    updateIsActionDisabledState(getValues(), nextValue);
  };
   const handleSubmitFunction = handleSubmit(submitHandler)

  return (
    <>
      <Text fontSize="30px" as="b">
        {constants.FFL_STORE_CONFIGURATION}
      </Text>
      <form className="ffl-store-config-form">
        {formMapping.map((formItem) => {
          return (
            <>
              <div className="ffl-store-config-form__form-item">
                <label
                  className="ffl-store-config-form__label"
                  htmlFor={formItem.fieldName}
                >
                  {formItem.label}
                </label>
                <Input
                  className="ffl-store-config-form__input"
                  {...register(formItem.fieldName as FormFields, {
                    onChange: onChangeFeild
                  })}
                  disabled={Boolean(!configDetails?.api_key) || formItem.isWebHook && isBigCommercePlatform || formItem.isWebHook && isWooCommercePlatform}
                />
              </div>
              {errors[formItem.fieldName as keyType<typeof errors>] &&
                errors[formItem.fieldName as keyType<typeof errors>]
                  ?.message && (
                  <div className="form-error">
                    {
                      errors[formItem.fieldName as keyType<typeof errors>]
                        ?.message
                    }
                  </div>
                )}
            </>
          );
        })}
        <div className="ffl-store-config-form__form-item">
          <label className="ffl-store-config-form__label" htmlFor="allowPreferredLicenseUpgrade">
            Allow Preferred License Upgrade
          </label>
          <Switch
            id="allowPreferredLicenseUpgrade"
            isChecked={allowPreferredLicenseUpgrade}
            onChange={onChangePreferredLicenseUpgrade}
            isDisabled={Boolean(!configDetails?.api_key)}
          />
        </div>
      </form>
      <div className="btn-wrappper">
        <Button
          colorScheme="blue"
          background="#ffffff"
          color="#0C1E46"
          border="1px solid #0C1E46"
          padding="8px 11px"
          marginRight="20px"
          onClick={onCancelHandler}
          isDisabled={isUpdatingStoreConfiguration || isActionDisabled}
        >
          {constants.CANCEL_TEXT}
        </Button>
        <Button
          colorScheme="blue"
          background="#0C1E46"
          padding="8px 20px"
          onClick={() => {logAnalyticsEvent(analyticsEvents.updateFFLSelectStoreConfig);  handleSubmitFunction();}}
          isLoading={isUpdatingStoreConfiguration}
          isDisabled={isUpdatingStoreConfiguration || isActionDisabled}
        >
          {constants.SAVE_TEXT}
        </Button>
      </div>
    </>
  );
}
